// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

const convertDataToServer = (
expertiseServiceGpmCost) => (
{
  ...expertiseServiceGpmCost,
  workHour: convertFromRubToKop(expertiseServiceGpmCost.workHour),
  materialsCost: convertFromRubToKop(expertiseServiceGpmCost.materialsCost),
  expertiseCost: convertFromRubToKop(expertiseServiceGpmCost.expertiseCost)
});

const convertDataFromServer = (
expertiseServiceGpmCost) => (
{
  ...expertiseServiceGpmCost,
  workHour: convertFromKopToRub(expertiseServiceGpmCost.workHour),
  materialsCost: convertFromKopToRub(expertiseServiceGpmCost.materialsCost),
  expertiseCost: convertFromKopToRub(expertiseServiceGpmCost.expertiseCost)
});

const expertiseServiceGpmCost = new CommonApi(
  'expertiseServiceGpmCost',
  'Стоимость ТО ГПМ и промышленной экспертизы',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...expertiseServiceGpmCost
};
